<template>
    <div>
        <button class="btn btn-primary--brand pt-2 pb-2" type="button" v-if="cropMode == false" @click="addWaveCropControls()">Amplitude Zuschneiden</button>
        <div class="font-italic mb-1" v-if="cropMode == true">Wähle den Ausschnitt deiner Amplitude aus, der am Bild angezeigt werden soll. Deine Audio wird dadurch nicht gekürzt!</div>
        <button class="btn btn-primary--brand pt-2 pb-2" type="button" v-if="cropMode == true" @click="removeWaveCropControls()">Zuschnitt speichern</button>
    </div>
</template>

<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import "~/scripts/Pipeline/_wavetransformers.js";
import Pipeline from "~/scripts/Pipeline/Pipeline.js";

export default {
    props: {
        open: Boolean
    },
    computed: {
        ...mapFields({
            cropModeActive: 'cropModeActive'
        }),
    },

    data() {
        return {
            cropMode: false
        };
    },

    mounted() {
        // allow activating crop mode from other components
        this.$root.$on('activateCropMode', () => {
            this.addWaveCropControls();
        });
    },

    methods: {
        addWaveCropControls() {
            this.cropMode = true;
            this.cropModeActive = true;
            Pipeline.initializeWaveTransformers();
        },

        removeWaveCropControls() {
            this.cropMode = false;
            this.cropModeActive = false;
            Pipeline.wavesDraggable();
            Pipeline.removeWaveTransformers();
        },
    },

    watch: {
        open() {
            if (this.open) {
                this.addWaveCropControls();
            } else if (this.cropMode) {
                this.removeWaveCropControls();
            }
        }
    }
}
</script>
